import React, {Component} from 'react';
import gif404 from './404.gif';
import {Breadcrumb, BreadcrumbItem} from "mdbreact";
import {Link} from "react-router-dom";

export default class NotFound extends Component {
    render() {
        return (
            <div>
                <div className="jumbotron text-center rtl">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2 text-right rtl">
                            <p className="pag-title">صفحه مورد نظر یافت نشد !</p>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>404 !</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container text-center rtl">
                    <h1 className="deep-purple-text">404!</h1>
                    <p className="deep-orange-text">صفحه مورد نظر یافت نشد !</p>
                    <img src={gif404} alt='404 gif'/>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/misc/NotFound.js